export default "__VITE_ASSET__128b6908__"